import { useState } from "react";
import { IRoadFeatureListItemProps } from "./RoadFeatureResponseList";
import { Collapse, Divider, ListItemButton, ListItemText } from "@mui/material";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import { SvenskeTrafikkmeldinger } from "../../RouteDescription/SvenskeTrafikkmeldinger";

export default function SwedishTrafficMessageListItem(props: IRoadFeatureListItemProps) {
  const [open, setOpen] = useState(false);

  const onClick = () => {
        setOpen((prevstate) => !prevstate);
  };

  return(
    <>
      {props.roadFeatureResponse && 
      props.roadFeatureResponse.swedishTrafficMessages && 
      props.roadFeatureResponse.swedishTrafficMessages.length !== 0 && 
      <>
      <ListItemButton
        onClick={onClick}>
          <ListItemText primary={`Svenske trafikkmeldinger (${props.roadFeatureResponse?.swedishTrafficMessages.length})`}/> 
          {open ? <ExpandLess /> : <ExpandMore />} 
        </ListItemButton>
        <Collapse
        in={open}
        timeout="auto" 
        unmountOnExit
        >
          <SvenskeTrafikkmeldinger roadFeatures={props.roadFeatureResponse} onClick={props.onClick} onMouseEnterItem={props.onMouseEnterItem} onMouseLeaveItem={props.onMouseLeaveItem}/>
        </Collapse>
        <Divider />
        </>
      }
    </>
  )
}